import type { ReactNode, Dispatch, SetStateAction } from 'react';
import React, { createContext, useContext, useMemo, useState } from 'react';

const SearchGroupContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([
  false,
  () => ({}),
]);

const Provider = (props: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false);
  const value = useMemo<[boolean, Dispatch<SetStateAction<boolean>>]>(
    () => [isVisible, setIsVisible],
    [isVisible],
  );
  return <SearchGroupContext.Provider value={value} {...props} />;
};

function useToggle() {
  const context = useContext(SearchGroupContext);
  const [isVisible, setIsVisible] = context;
  const onToggle = (val: boolean) => {
    setIsVisible(val);
  };

  return {
    isVisible,
    setIsVisible,
    onToggle,
  };
}

export default { Provider, useToggle };
